import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchModal'

export default defineMessages({
  modalAriaLabel: {
    id: `${scope}.modalAriaLabel`,
    defaultMessage: 'Global search',
  },
  closeButtonAriaLabel: {
    id: `${scope}.closeButtonAriaLabel`,
    defaultMessage: 'Close',
  },
  enterToSearchHint: {
    id: `${scope}.enterToSearchHint`,
    defaultMessage: '\u23CE Enter to search',
  },
})
